import { CreateNS } from '../lib/createAPIBuilder';

import { installAPIAffiliate } from './installAPIAffiliate';
import { installAPIApplication } from './installAPIApplication';
import { installAPIAtRoot } from './installAPIAtRoot';
import { installAPIAuth } from './installAPIAuth';
import { installAPIBrand } from './installAPIBrand';
import { installAPIChapterHistory } from './installAPIChapterHistory';
import { installAPIConsent } from './installAPIConsent';
import { installAPIDevice } from './installAPIDevice';
import { installAPIDevMode } from './installAPIDevMode';
import { installAPILifecycle } from './installAPILifecycle';
import { installAPIMonitoring } from './installAPIMonitoring';
import { installAPINative, installAtNativeSession } from './installAPINative';
import { installAPINavigation } from './installAPINavigation';
import { installAPIOptimizely } from './installAPIOptimizely';
import { installAPIPubby } from './installAPIPubby';
import { installAPISplashScreen } from './installAPISplashScreen';
import { installAPIStartupData } from './installAPIStartupData';

export const installAPI = (namespace: CreateNS) => {
    installAPIApplication(namespace);
    installAPIAtRoot(namespace);
    installAPIAuth(namespace);
    installAPIChapterHistory(namespace);
    installAPIConsent(namespace);
    installAPIDevice(namespace);
    installAPIDevMode(namespace);
    installAPILifecycle(namespace);
    installAPINavigation(namespace);
    installAPIOptimizely(namespace);
    installAPISplashScreen(namespace);
    installAPIStartupData(namespace);
    installAPINative(namespace);
    installAtNativeSession(namespace);
    installAPIMonitoring(namespace);
    installAPIPubby(namespace);
    installAPIBrand(namespace);
    installAPIAffiliate(namespace);
    // Finalise initialisation
    namespace(null)(({ prop }) => {
        prop('publicApiInitialised', () => true, null);
        const targetGarbageContainerSnapshot: unknown[] = [];
        // @ts-expect-error FIXME: remove once chapters removed the reference
        prop(
            'targetGarbageContainerSnapshot',
            () => targetGarbageContainerSnapshot,
        );
    });
};
